export const SET_IDEMPOTENCY_KEY = 'SET_IDEMPOTENCY_KEY';

export const setIdempotencyKey = (hashKey, dataObject) => ({
	type: SET_IDEMPOTENCY_KEY,
	hashKey,
	dataObject,
});
